<template>
  <div class="my-wrap finance-wrap">
    <div class="withdraw-frame withdraw-m-frame">
      <!-- ══════════════ Mobile 版 ══════════════ -->
      <div class="my-withdraw-mobile-package withdraw-mobile">
        <div class="mobile-frame">
          <!-- Mobile tab 導覽 -->
          <WithdrawTabNav
            :is-crypto-exchange="isCryptoExchange"
            @toggle-mode="displayCryptoChange"
          />

          <div class="slider-form withdraw-slider-form">
            <div class="slider">
              <form class="row-frame dep-form-frame gx-3 form-row-gap">
                <!--mb 幣種 + 鏈/錢包選單 -->
                <CoinSelector
                  :is-crypto="withdrawType === 3"
                  :is-crypto-exchange="isCryptoExchange"
                  :selected-coin="selectedCoin"
                  :selected-wallet="selectedWallet"
                  :coin-list="coinList"
                  :main-wallet="mainWallet"
                  @select-crypto="onSelectCrypto"
                  @select-chain="onSelectChain"
                  @select-non-crypto="selectNonCryptoWallet"
                />
                <WalletSelector
                  :is-crypto="withdrawType === 3"
                  :selected-wallet="selectedWallet"
                  :selected-wallet-key="selectedWalletKey"
                  :selected-chain="selectedChain"
                  :non-crypto-wallets="nonCryptoWallets"
                  :chain-list="chainList"
                  @select-non-crypto="selectNonCryptoWallet"
                  @select-chain="onSelectChain"
                />

                <!--mb 金額輸入 -->
                <AmountInput
                  :amount.sync="postForm.amount"
                  :withdrawal-limit="withdrawalLimit"
                  :amount-limit="amount_limit"
                  :is-crypto-exchange="isCryptoExchange"
                  :currency="brand.currency"
                  :is-integer-wallet="isIntegerWallet"
                  input-id="withdraw-amount-mb"
                  @set-all="setAllAmount"
                />
                <WithdrawLimitInfo
                  :withdrawal-limit="withdrawalLimit"
                  :amount-limit="amount_limit"
                  :is-crypto-exchange="isCryptoExchange"
                  :currency="brand.currency"
                  input-id="withdraw-amount-mb"
                />

                <hr class="withdraw-pw-divider">

                <!--mb 加密幣地址 -->
                <div v-if="withdrawType === 3 && isCryptoSelect" class="colu-12">
                  <label class="colu-12 for-label" for="crypto-address-mb">
                    {{ $t('Bao.withdrawal_address') }}
                  </label>
                  <input
                    id="crypto-address-mb"
                    v-model="postForm.address"
                    v-validate="'required'"
                    class="for-input inpType"
                    :class="{ 'isInvalid': errors.has('address-mb') }"
                    type="text"
                    :placeholder="$t('Bao.withdrawal_address')"
                    autocomplete="off"
                    name="address-mb"
                  >
                  <div v-if="errors.has('address-mb')" class="input-feedback text-align-R">
                    {{ $t('Bao.wallet_address_error') }}
                  </div>
                </div>

                <!--mb Destination Tag -->
                <DestinationTagInput
                  v-if="selectedChain && selectedChain.supportMemo"
                  :selected-chain="selectedChain"
                  :memo.sync="memo"
                  @copy="copyTextHelper"
                />

                <!--mb 銀行卡 / Jeton / Vega -->
                <PaymentUseBank
                  v-if="withdrawType !== 3"
                  :show-bank-select="withdrawType !== 3"
                  :member-bank-id="postForm.member_bank_id"
                  :selected-bank-name="selectedBankName"
                  :my-banks="myBanks"
                  @select-bank="onSelectBank"
                />
                <PaymentUseJeton
                  v-if="withdrawType !== 3 && selectedBankTypeCode === 'JetonPay'"
                  :withdrawal-info="withdrawal_info"
                  :jeton-errors="jetonErrors"
                  @update:withdrawal-info="withdrawal_info = $event"
                  @check-jeton-errors="checkJetonErrors"
                />
                <PaymentUseVega
                  v-if="withdrawType !== 3 && selectedBankTypeCode === 'VegaWallet'"
                  :withdrawal-info="withdrawal_info"
                  :account-errors="accountErrors"
                  @update:withdrawal-info="withdrawal_info = $event"
                  @check-account-errors="checkAccountErrors"
                />

                <!-- mb 提款密碼 / Google Auth -->
                <AuthInput
                  :google-auth-enabled="google_auth_totp_status"
                  :withdrawal-pass.sync="postForm.withdrawal_pass"
                  :otp-code.sync="postForm.opt_code"
                  input-id="auth-input-mb"
                />

                <!-- mb 總計 + 同意條款 -->
                <WithdrawSummary
                  :is-crypto-exchange="isCryptoExchange"
                  :is-crypto="withdrawType === 3"
                  :display-amount="postForm.amount > 0 ? postForm.amount : 0"
                  :transfer-value="transferValue"
                  :target-crypto="transferPostForm.toWallet"
                  :bonus-gold="bonusGold"
                  :currency="brand.currency"
                />

                <AgreeCheckbox
                  :agree.sync="agree"
                  :agree-tip="agreeTip"
                  checkbox-id="agree-mb"
                />
              </form>
            </div>
          </div>

          <!-- mb 送出按鈕 -->
          <div
            class="button-style-w100 btn-primary"
            :class="{ disabled: !checkInput() }"
            @click="isCryptoExchange ? sendTransfer() : checkIsWithdraw()"
          >
            {{ $t('Bao.send') }}
          </div>

          <div v-if="themeConfig.showWithdrawalDesc" @click="$router.push('/page/support')">
            <a class="help-deposit-n">
              <span class="icon-help">?</span>
              <span class="help-text">{{ $t('Bao.withdrawal_description') }}</span>
            </a>
          </div>
        </div>
      </div>
      <!-- Mobile end -->

      <!-- ══════════════ PC 版 ══════════════ -->
      <div class="pc-withdraw-layout">
        <!-- PC 側邊欄 -->
        <WithdrawSidebar
          :is-crypto-exchange="isCryptoExchange"
          @toggle-mode="displayCryptoChange"
        />

        <div class="my-withdraw-frame">
          <div class="my-deposit my-d-box">
            <div class="slider-form withdraw-container">
              <div class="slider">
                <form class="row-frame dep-form-frame gx-3 form-row-gap">
                  <!-- 幣種 + 鏈/錢包選單 -->
                  <CoinSelector
                    :is-crypto="withdrawType === 3"
                    :is-crypto-exchange="isCryptoExchange"
                    :selected-coin="selectedCoin"
                    :selected-wallet="selectedWallet"
                    :coin-list="coinList"
                    :main-wallet="mainWallet"
                    @select-crypto="onSelectCrypto"
                    @select-chain="onSelectChain"
                    @select-non-crypto="selectNonCryptoWallet"
                  />
                  <WalletSelector
                    :is-crypto="withdrawType === 3"
                    :selected-wallet="selectedWallet"
                    :selected-wallet-key="selectedWalletKey"
                    :selected-chain="selectedChain"
                    :non-crypto-wallets="nonCryptoWallets"
                    :chain-list="chainList"
                    @select-non-crypto="selectNonCryptoWallet"
                    @select-chain="onSelectChain"
                  />

                  <!-- 金額輸入 -->
                  <AmountInput
                    :amount.sync="postForm.amount"
                    :is-crypto-exchange="isCryptoExchange"
                    :is-integer-wallet="isIntegerWallet"
                    input-id="withdraw-amount-pc"
                    @set-all="setAllAmount"
                  />

                  <WithdrawLimitInfo
                    :withdrawal-limit="withdrawalLimit"
                    :amount-limit="amount_limit"
                    :is-crypto-exchange="isCryptoExchange"
                    :currency="brand.currency"
                    input-id="withdraw-amount-pc"
                  />

                  <hr class="withdraw-pw-divider">

                  <!-- 銀行卡 / Jeton / Vega -->
                  <PaymentUseBank
                    v-if="withdrawType !== 3"
                    :show-bank-select="withdrawType !== 3"
                    :member-bank-id="postForm.member_bank_id"
                    :selected-bank-name="selectedBankName"
                    :my-banks="myBanks"
                    @select-bank="onSelectBank"
                  />
                  <PaymentUseJeton
                    v-if="withdrawType !== 3 && selectedBankTypeCode === 'JetonPay'"
                    :withdrawal-info="withdrawal_info"
                    :jeton-errors="jetonErrors"
                    @update:withdrawal-info="withdrawal_info = $event"
                    @check-jeton-errors="checkJetonErrors"
                  />
                  <PaymentUseVega
                    v-if="withdrawType !== 3 && selectedBankTypeCode === 'VegaWallet'"
                    :withdrawal-info="withdrawal_info"
                    :account-errors="accountErrors"
                    @update:withdrawal-info="withdrawal_info = $event"
                    @check-account-errors="checkAccountErrors"
                  />

                  <!-- 加密幣地址 -->
                  <div v-if="withdrawType === 3 && isCryptoSelect" class="colu colu-12">
                    <label class="colu-12 for-label">
                      {{ $t('Bao.withdrawal_address') }}
                    </label>
                    <input
                      v-model="postForm.address"
                      v-validate="'required'"
                      class="for-input inpType"
                      :class="{ 'isInvalid': errors.has('address-pc') }"
                      type="text"
                      :placeholder="$t('Bao.withdrawal_address')"
                      autocomplete="off"
                      name="address-pc"
                    >
                    <div v-if="errors.has('address-pc')" class="input-feedback text-align-R">
                      {{ $t('Bao.wallet_address_error') }}
                    </div>
                  </div>

                  <!-- Destination Tag -->
                  <DestinationTagInput
                    v-if="selectedChain && selectedChain.supportMemo"
                    :selected-chain="selectedChain"
                    :memo.sync="memo"
                    @copy="copyTextHelper"
                  />

                  <!-- 提款密碼 / Google Auth -->
                  <AuthInput
                    :google-auth-enabled="google_auth_totp_status"
                    :withdrawal-pass.sync="postForm.withdrawal_pass"
                    :otp-code.sync="postForm.opt_code"
                    input-id="auth-input-pc"
                  />

                  <!-- 總計 -->
                  <WithdrawSummary
                    :is-crypto-exchange="isCryptoExchange"
                    :is-crypto="withdrawType === 3"
                    :display-amount="postForm.amount > 0 ? postForm.amount : 0"
                    :transfer-value="transferValue"
                    :target-crypto="transferPostForm.toWallet"
                    :bonus-gold="bonusGold"
                    :currency="brand.currency"
                    :agree.sync="agree"
                    :agree-tip="agreeTip"
                    checkbox-id="agree-pc"
                  />

                  <!-- 同意條款 -->
                  <AgreeCheckbox
                    :agree.sync="agree"
                    :agree-tip="agreeTip"
                    checkbox-id="agree-pc"
                  />

                  <!-- 送出按鈕 -->
                  <div
                    class="button-style-w100 btn-primary"
                    :class="{ disabled: !checkInput() }"
                    @click="isCryptoExchange ? sendTransfer() : checkIsWithdraw()"
                  >
                    {{ $t('Bao.send') }}
                  </div>

                  <div v-if="themeConfig.showWithdrawalDesc" @click="$router.push('/page/support')">
                    <a class="help-deposit-n">
                      <span class="icon-help">?</span>
                      <span class="help-text">{{ $t('Bao.withdrawal_description') }}</span>
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- PC end -->
    </div>

    <!-- ── 確認送出 Modal ── -->
    <div v-if="showModel" class="popup-wrap text-center" :class="{ active: showModel }">
      <div class="popup-box">
        <div class="popup-success">
          <h5>{{ handleWithdrawText }}</h5>
          <button class="button-style-5" @click="doWithdrawal">
            <span>{{ $t('Bao.submit') }}</span>
          </button>
          <button class="button-style-5" @click="showModel = false">
            <span>{{ $t('Bao.cancel') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  withdrawal, withdrawalCheck, withdrawalWallet, withdrawalPayment,
  getCoinlist, walletTransferRate, walletTransfer
} from '@/api/payment'
import { getMyBanks } from '@/api/bank'
import { info } from '@/api/user'
import { page } from '@/api/common'
import { showNotice, setErrorMessage, copyText, getWalletImagePath, detectMob } from '@/utils/tool'
import crypto from 'crypto-js'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'
import paymentMixin from '@/mixins/paymentMixin'

import WithdrawTabNav from '@/views/withdraw/WithdrawTabNav'
import WithdrawSidebar from '@/views/withdraw/WithdrawSidebar'
import CoinSelector from '@/views/withdraw/CoinSelector'
import WalletSelector from '@/views/withdraw/WalletSelector'
import AmountInput from '@/views/withdraw/AmountInput'
import WithdrawLimitInfo from '@/views/withdraw/WithdrawLimitInfo'
import DestinationTagInput from '@/views/withdraw/DestinationTagInput'
import AuthInput from '@/views/withdraw/AuthInput'
import WithdrawSummary from '@/views/withdraw/WithdrawSummary'
import AgreeCheckbox from '@/views/withdraw/AgreeCheckBox'
import PaymentUseBank from '@/views/withdraw/PaymentUseBank.vue'
import PaymentUseJeton from './PaymentUseJeton.vue'
import PaymentUseVega from './PaymentUseVega.vue'

export default {
  components: {
    WithdrawTabNav,
    WithdrawSidebar,
    AmountInput,
    WithdrawLimitInfo,
    PaymentUseBank,
    PaymentUseJeton,
    PaymentUseVega,
    DestinationTagInput,
    AuthInput,
    WithdrawSummary,
    AgreeCheckbox,
    CoinSelector,
    WalletSelector
  },
  mixins: [themeMixin, paymentMixin],

  data() {
    return {
      withdrawType: '',
      myBanks: [],
      selectedBankName: this.$t('Bao.select_bankcard'),
      selectedBankTypeCode: '',
      wallets: [],
      selectedWallet: null,
      withdrawalCheckData: {
        amount: null,
        withdrawal_fee: null,
        actual_amount: null,
        status: null,
        require_performance: null,
        performance_need: null,
        current_performance: null
      },
      agree: false,
      postForm: {
        wallet_type: 'main',
        amount: '',
        withdrawal_pass: null,
        opt_code: null,
        member_bank_id: this.$t('Bao.select_bankcard'),
        address: null
      },
      withdrawal_info: {},
      accountErrors: [' '],
      jetonErrors: [' '],
      showModel: false,
      availableWithdrawalTypes: { 1: false, 2: false, 3: true },
      isMainWallet: true,
      isCryptoSelect: true,
      coinList: [],
      chainList: [],
      mainWallet: null,
      selectedCoin: null,
      selectedChain: null,
      selectedWalletKey: null,
      memo: '',
      loadCoinApi: false,
      isWithdraw: true,
      JPchainList: [
        { chain: 'USDT', supportMemo: false },
        { chain: 'XRP', supportMemo: false },
        { chain: 'LTC', supportMemo: false }
      ],
      transRateList: [],
      transferValue: 0,
      rateJPtoUSDT: 0,
      activeJPtoUSDT: '',
      rateUSDTtoOther: 0,
      activeUSDTtoOther: '',
      transferPostForm: {
        fromWallet: 'main',
        toWallet: 'USDT',
        amount: 0
      },
      isWithdrawalFull: false,
      fullAmount: 0,
      agreeTip: '',
      paymentFeeData: [],
      typeDescriptions: {}
    }
  },

  computed: {
    ...mapGetters(['memberInfo', 'brand', 'brandInfo', 'bonusGold', 'user', 'permissionInfo', 'app']),

    before_withdrawal_module_setting() {
      return this.brandInfo.before_withdrawal_module_setting
    },
    max_withdrawal_amount() {
      return this.before_withdrawal_module_setting
        ? this.before_withdrawal_module_setting.max_withdrawal_amount
        : 0
    },
    handleWithdrawText() {
      return this.$t('Bao.is_handle_withdraw', { limit: this.max_withdrawal_amount })
    },
    first_deposit_at() {
      return this.memberInfo.first_deposit_at
    },
    google_auth_totp_status() {
      return this.user.authStatus && this.permissionInfo.enable_google_totp
    },
    isCryptoExchange() {
      return this.$route.query.mode === 'crypto-exchange'
    },
    /** 只含 main / commission 的錢包，給 WithdrawSelector 用 */
    nonCryptoWallets() {
      return this.wallets.filter(w => w.key === 'main' || w.key === 'commission')
    },
    /** 目前選中錢包是否為整數型（main / commission），決定 AmountInput 是否限制整數 */
    isIntegerWallet() {
      return !this.selectedWallet ||
        this.selectedWallet.wallet_type === 'main' ||
        this.selectedWallet.wallet_type === 'commission'
    },
    filteredWallets() {
      const hasCrypto = this.availableWithdrawalTypes[3]
      const hasNonCrypto = this.availableWithdrawalTypes[1] || this.availableWithdrawalTypes[2]
      let result = []

      if (this.withdrawType === 3) {
        result = this.wallets.filter(w => w.key !== 'main' && w.key !== 'commission')
      } else if (this.withdrawType === 1 || this.withdrawType === 2) {
        result = this.wallets.filter(w => w.key === 'main' || w.key === 'commission')
      } else {
        if (hasCrypto && hasNonCrypto) result = this.wallets
        else if (hasCrypto) result = this.wallets.filter(w => w.key !== 'main' && w.key !== 'commission')
        else if (hasNonCrypto) result = this.wallets.filter(w => w.key === 'main' || w.key === 'commission')
      }

      const sortOrder = ['main', 'bonus', 'commission']
      return result.slice().sort((a, b) => {
        const ai = sortOrder.indexOf(a.key)
        const bi = sortOrder.indexOf(b.key)
        return (ai === -1 ? sortOrder.length : ai) - (bi === -1 ? sortOrder.length : bi)
      })
    },
    withdrawalLimit() {
      const wallet = (!this.isCryptoSelect && this.withdrawType === 3) ? this.mainWallet : this.selectedWallet
      if (wallet && wallet.withdrawal_limit && this.filteredWallets.length > 0) {
        const limit = parseFloat(wallet.withdrawal_limit) - parseFloat(wallet.turnover)
        return limit > 0 ? Math.floor(limit * 1e6) / 1e6 : 0
      }
      return 0
    },
    amount_limit() {
      const wallet = (!this.isCryptoSelect && this.withdrawType === 3) ? this.mainWallet : this.selectedWallet
      if (wallet && wallet.amount_limit && this.filteredWallets.length > 0) {
        if (wallet.name === 'main' || wallet.name === 'commission') {
          return parseInt(wallet.amount_limit.max)
        } else {
          return Math.floor(Number(wallet.amount_limit.max) * 1e6) / 1e6
        }
      } else if (wallet && wallet.symbol) {
        const cryptoWallet = this.wallets.find(item => item.name === wallet.symbol)
        const limit = Math.floor(Number(cryptoWallet.amount_limit.max) * 1e6) / 1e6
        return limit > 0 ? limit : 0
      }
      if (!this.isCryptoSelect && this.withdrawType === 3) {
        return parseInt(wallet.balance)
      }
      return 0
    }
  },

  watch: {
    filteredWallets(newList) {
      if (newList.length === 0) {
        this.selectedWallet = null
        this.postForm.wallet_type = null
      } else if (this.withdrawType === 1 || this.withdrawType === 2) {
        const key = this.isMainWallet ? 'main' : 'commission'
        this.postForm.wallet_type = key
        this.selectedWallet = this.getWalletByKey(key)
        this.selectedWalletKey = key
      }
    },
    selectedCoin: {
      handler(newCoin) {
        if (newCoin && newCoin.networks) {
          this.chainList = Object.values(newCoin.networks).map(network => ({
            chain: network.chain,
            supportMemo: network.supportMemo
          }))
          this.selectedChain = this.chainList[0] || null
          this.selectedWallet = newCoin
          this.postForm.wallet_type = newCoin.symbol
        } else if (!this.isCryptoExchange) {
          this.chainList = []
          this.selectedChain = null
        }
      },
      immediate: true
    }
  },

  created() {
    // Lite player 強制跳轉設定頁
    if (this.memberInfo.member_type === 3 && this.memberInfo.withdrawal_pass === '') {
      this.$router.push('/user/edit')
    }

    // 從個人頁進來，預選佣金錢包
    if (localStorage.getItem('fromPersonalToWithdrawal')) {
      localStorage.removeItem('fromPersonalToWithdrawal')
      this.postForm.wallet_type = 'commission'
      this.isMainWallet = false
    }

    const selectedWallet = this.app.selectedWallet
    if (this.isTheme('theme_purple')) {
      // purple 沒有主錢包，固定走加密幣模式
      this.withdrawType = 3
    } else if (!selectedWallet || Object.keys(selectedWallet).length === 0 ||
      ['main', 'commission', 'bonus'].includes(selectedWallet.wallet_type)) {
      this.withdrawType = 2
    } else {
      this.withdrawType = 3
    }

    if (this.isCryptoExchange) this.withdrawType = 3

    page({ type: 'withdraw_agreement' }).then(response => {
      this.agreeTip = response.data.data.content
    })

    withdrawalWallet().then((response) => {
      this.wallets = response.data.data
      this.mainWallet = this.buildMainWallet()

      const sw = this.app.selectedWallet
      const isCryptoWallet = sw &&
            Object.keys(sw).length > 0 &&
            this.wallets.some(w => w.key === sw.wallet_type)

      if (this.isCryptoExchange) {
        this.selectedWallet = this.getWalletByKey('main')
        this.selectedWalletKey = 'main'
        this.isCryptoSelect = false
        this.chainList = this.JPchainList
        this.selectedChain = this.chainList[0]
        this.transferPostForm.toWallet = this.selectedChain.chain
        this.loadTransferRate()
      } else if (isCryptoWallet) {
        this.selectedCoin = {
          symbol: sw.wallet_type,
          balance: sw.balance ?? '0',
          networks: sw.networks ?? null
        }
        this.selectedWallet = this.selectedCoin
        this.selectedWalletKey = sw.wallet_type
        this.postForm.wallet_type = sw.wallet_type
        this.loadCoinList()
      } else {
        // purple 沒有主錢包，等 loadCoinList 完成後選第一個加密幣，避免閃現主錢包
        if (!this.isTheme('theme_purple')) {
          this.selectedWallet = this.getWalletByKey('main')
          this.selectedWalletKey = 'main'
        }
        this.loadCoinList()
      }
    }).catch((error) => {
      setErrorMessage(error.response, this.errors)
    })

    getMyBanks().then((response) => {
      this.myBanks = response.data.data
      this.checkAvailableWithdrawalTypes()
    }).catch((error) => {
      setErrorMessage(error.response, this.errors)
    })

    if (this.withdrawalLimit !== 0 && this.postForm.wallet_type === 'main') {
      showNotice(this.$t('Bao.no_withdrawal_limit', { limit: this.withdrawalLimit }))
    }

    if (this.first_deposit_at === 0) {
      info().then(response => {
        this.$store.dispatch('SetUserData', response.data.data)
      })
    }

    this.preloadTypeDescriptions([1, 2, 3])
  },

  methods: {
    getWalletImagePath,

    // ── 錢包 helpers ──────────────────────────────────────────
    getWalletByKey(key) {
      const wallet = this.wallets.find(w => w.key === key)
      if (!wallet) return {}
      const matchInfo = this.user.walletInfo.find(info => info.wallet_type === wallet.wallet_type)
      return {
        ...wallet,
        withdrawal_limit: matchInfo ? matchInfo.withdrawal_limit : null,
        turnover: matchInfo ? matchInfo.turnover : 0
      }
    },

    // ── 幣種 / 鏈選擇事件 ────────────────────────────────────
    onSelectCrypto(coin) {
      this.withdrawType = 3
      this.selectCrypto(coin)
    },
    onSelectChain(chainObj) {
      this.selectedChain = chainObj
      this.handleCryptoChange()
    },
    selectNonCryptoWallet(wallet) {
      if (!this.isCryptoExchange) {
        this.withdrawType = 2
        this.selectedCoin = null
        this.selectedChain = null
        this.chainList = []
      }
      this.selectedWalletKey = wallet.key
      this.selectedWallet = this.getWalletByKey(wallet.key)
      this.postForm.wallet_type = wallet.key
    },

    // ── 銀行卡選擇 ───────────────────────────────────────────
    onSelectBank(bank) {
      this.selectedBankName = bank.card_number
      this.postForm.member_bank_id = bank.id
      this.selectedBankTypeCode = bank.code || ''
      this.withdrawal_info = {}
    },

    // ── 加密幣 ───────────────────────────────────────────────
    selectCrypto(coin) {
      this.selectedCoin = coin
      this.isCryptoSelect = true
      const matchedFee = this.paymentFeeData.find(fee => fee.code === coin.symbol)
      this.selectedCoin.payment_fee = matchedFee?.payments?.[0]?.payment_fee?.member
    },
    handleCryptoChange() {
      this.transferPostForm.toWallet = this.selectedChain.chain
      const matched = this.transRateList.find(
        item => item.fromCurrency === 'JPY' && item.toCurrency === this.selectedChain.chain
      )
      if (!matched?.rateInfo) return

      const matchedRateUSD = matched.rateInfo.find(item => item.memo === 'USD轉為JPY的匯率')
      if (!matchedRateUSD) return
      this.rateJPtoUSDT = matchedRateUSD.rate
      this.activeJPtoUSDT = matchedRateUSD.action

      const matchedRateOther = matched.rateInfo.find(
        item => item.memo === 'USDT轉為' + this.selectedChain.chain + '的匯率'
      )
      if (!matchedRateOther) return
      this.rateUSDTtoOther = matchedRateOther.rate
      this.activeUSDTtoOther = matchedRateOther.action
    },

    // ── 全額提款 ─────────────────────────────────────────────
    setAllAmount() {
      if (!this.selectedWallet) { this.postForm.amount = 0; return }
      if (this.selectedWallet.wallet_type === 'main' || this.selectedWallet.wallet_type === 'commission') {
        this.postForm.amount = parseInt(this.selectedWallet['amount_limit'].max)
      } else {
        this.isWithdrawalFull = true
        const cryptoWallet = this.wallets.find(item => item.name === this.selectedWallet.symbol)
        this.fullAmount = Number(cryptoWallet.amount_limit.max)
        const limit = Math.floor(this.fullAmount * 1e6) / 1e6
        this.postForm.amount = limit > 0 ? limit : 0
      }
    },

    // ── 驗證 ─────────────────────────────────────────────────
    checkInput() {
      const amountValid = this.postForm.amount !== '' && !isNaN(this.postForm.amount)
      const hasWallet = !!this.selectedWallet
      const passedAuth = this.google_auth_totp_status
        ? !!this.postForm.opt_code
        : !!this.postForm.withdrawal_pass
      const hasAgreed = this.agree
      const bankSelected = !isNaN(this.postForm.member_bank_id)
      const isJetonInvalid = this.selectedBankTypeCode === 'JetonPay' && this.jetonErrors.length > 0
      const isVegaInvalid = this.selectedBankTypeCode === 'VegaWallet' &&
        (!this.withdrawal_info.password || this.accountErrors.length > 0)

      if (this.withdrawType === 3 && !this.isCryptoSelect) {
        this.getTransferValue()
        return amountValid && hasWallet && this.isWithdraw && hasAgreed && passedAuth
      }

      return amountValid && hasWallet && this.isWithdraw &&
        (this.withdrawType === 3 || bankSelected) &&
        (this.withdrawType === 3 ? !!this.postForm.address : true) &&
        (this.withdrawType === 3 ? !!this.selectedChain : true) &&
        (this.withdrawType === 3 ? !!this.selectedCoin : true) &&
        (this.withdrawType === 3 && this.selectedChain?.supportMemo ? !!this.memo : true) &&
        hasAgreed && passedAuth && !isJetonInvalid && !isVegaInvalid
    },
    checkAccountErrors() {
      this.accountErrors = []
      if (!this.withdrawal_info.uid || !/^[a-zA-Z]\d{6}$/.test(this.withdrawal_info.uid)) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      }
    },
    checkJetonErrors() {
      this.jetonErrors = []
      if (!this.withdrawal_info.uid || !/^\d+$/.test(this.withdrawal_info.uid)) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      }
    },

    // ── 送出流程 ─────────────────────────────────────────────
    checkIsWithdraw() {
      if (this.postForm.amount <= 0 || isNaN(this.postForm.amount)) {
        showNotice(this.$t('Bao.withdrawal_amount') + ' ' + this.$t('Bao.need_over_zero'))
        return
      }
      if (this.postForm.wallet_type !== 'commission' &&
        this.first_deposit_at === 0 &&
        this.before_withdrawal_module_setting !== null) {
        if (this.postForm.amount > this.max_withdrawal_amount) {
          this.postForm.amount = this.max_withdrawal_amount
        }
        this.showModel = true
      } else {
        this.doWithdrawal()
      }
    },
    doWithdrawal() {
      this.showModel = false
      const withdrawAmount = this.isWithdrawalFull ? this.fullAmount : this.postForm.amount

      withdrawalCheck({ amount: withdrawAmount, wallet_type: this.postForm.wallet_type })
        .then((response) => {
          if (response.data.data.status === 'deny') {
            showNotice(response.data.data.message)
          } else {
            this.withdrawalCheckData = response.data.data
          }
        })
        .catch(() => console.log('Cannot get wallet type'))

      // 組裝送出資料
      const encryptedPostForm = { ...this.postForm }

      if (this.withdrawType === 3) {
        encryptedPostForm.chain = this.selectedChain.chain
        encryptedPostForm.member_bank_id = null
        encryptedPostForm.memo = this.selectedChain.supportMemo ? this.memo : ' '
      } else {
        encryptedPostForm.address = null
        delete encryptedPostForm.chain
        delete encryptedPostForm.memo
      }

      if (this.selectedBankTypeCode === 'VegaWallet') {
        encryptedPostForm.withdrawal_info = {
          ...this.withdrawal_info,
          password: crypto.MD5(this.withdrawal_info.password).toString()
        }
      } else if (this.selectedBankTypeCode === 'JetonPay') {
        encryptedPostForm.withdrawal_info = { ...this.withdrawal_info }
      } else {
        delete encryptedPostForm.withdrawal_info
      }

      const withdrawalInfoString = JSON.stringify(encryptedPostForm.withdrawal_info)

      withdrawalPayment({ ...encryptedPostForm, withdrawal_info: withdrawalInfoString })
        .then((response) => {
          showNotice(response.data.msg, () => {
            this.$router.push({ path: '/user/transaction-history?type=withdrawRecord' })
          })
        })
        .catch((error) => {
          setErrorMessage(error.response, this.errors)
        })
    },

    // ── 加密兌換 ─────────────────────────────────────────────
    getTransferValue() {
      this.transferPostForm.amount = this.postForm.amount
      let v = this.activeJPtoUSDT === 'multiply'
        ? this.postForm.amount * this.rateJPtoUSDT
        : this.postForm.amount / this.rateJPtoUSDT
      v = this.activeUSDTtoOther === 'multiply' ? v * this.rateUSDTtoOther : v / this.rateUSDTtoOther
      this.transferValue = Math.trunc(v * 1e6) / 1e6
    },
    sendTransfer() {
      walletTransfer(this.transferPostForm)
        .then((response) => {
          const code = Math.abs(response.data.data.code)
          const key = code === 1 ? 'Bao.withdrawal_transfer_success' : `Bao.withdrawal_error_${code}`
          showNotice(this.$t(key), () => {
            if (code === 1) this.$router.push({ path: '/user/transaction-history?type=other' })
          })
        })
        .catch((error) => setErrorMessage(error.response, this.errors))
    },

    // ── 頁面模式切換 ─────────────────────────────────────────
    displayCryptoChange() {
      const nextIsCryptoExchange = !this.isCryptoExchange
      if (nextIsCryptoExchange) {
        this.initCryptoExchangeMode()
      } else {
        this.withdrawType = 2
        this.isCryptoSelect = true
        this.rateJPtoUSDT = 0
        this.rateUSDTtoOther = 0
        this.transferValue = 0
        this.postForm.amount = ''
        this.selectedCoin = null
        this.selectedChain = null
        this.chainList = []
        if (!this.loadCoinApi) this.loadCoinList()
      }
      this.$router.replace({
        query: { ...this.$route.query, mode: nextIsCryptoExchange ? 'crypto-exchange' : undefined }
      }).catch(() => {})
    },
    initCryptoExchangeMode() {
      this.isCryptoSelect = false
      this.selectedWallet = this.getWalletByKey('main')
      this.selectedWalletKey = 'main'
      this.postForm.wallet_type = 'main'
      this.mainWallet = this.buildMainWallet()
      this.withdrawType = 3
      this.chainList = this.JPchainList
      this.selectedChain = this.chainList[0]
      this.transferPostForm.toWallet = this.selectedChain.chain
      this.selectedCoin = null
      this.loadTransferRate()
    },

    buildMainWallet() {
      const raw = this.wallets.length > 0
        ? this.getWalletByKey('main')
        : this.app.selectedWallet
      return {
        ...raw,
        currency: 'JPY',
        symbol: 'JPY',
        wallet_type: 'main',
        key: 'main'
      }
    },

    // ── API ─────────────────────────────────────────────────
    loadCoinList() {
      this.loadPaymentFee()
      getCoinlist().then((response) => {
        const rawList = response.data.data.filter(item =>
          this.wallets.some(wallet => wallet.key === item.symbol)
        )

        const walletInfo = this.user.walletInfo || []
        this.coinList = rawList.map(item => {
          const matchedWallet = walletInfo.find(w => w.wallet_type === item.symbol)
          const matchedFilteredWallet = this.wallets.find(w => w.wallet_type === item.symbol)
          const balance = matchedWallet?.balance
            ? Math.floor(parseFloat(matchedWallet.balance) * 1e6) / 1e6
            : 0
          return {
            ...item,
            balance: matchedWallet ? balance.toFixed(6) : '0',
            withdrawal_limit: matchedWallet?.withdrawal_limit ?? '0',
            turnover: matchedWallet?.turnover ?? '0',
            amount_limit: matchedFilteredWallet?.amount_limit ?? {}
          }
        })

        if (this.selectedCoin) {
          const fullCoin = this.coinList.find(c => c.symbol === this.selectedCoin.symbol)
          if (fullCoin) {
            this.selectCrypto(fullCoin)
          } else if (this.isTheme('theme_purple') && this.coinList.length > 0 && !this.isCryptoExchange) {
            // purple 主題：沒有主錢包，預設第一個加密幣
            this.selectedCoin = null
            this.selectCrypto(this.coinList[0])
          } else {
            // wallet 不存在，重置回 JPY
            this.selectedCoin = null
            this.selectedWallet = this.getWalletByKey('main')
            this.selectedWalletKey = 'main'
            this.postForm.wallet_type = 'main'
            this.withdrawType = 2
          }
          this.loadCoinApi = true
          return
        }

        // purple 主題：沒有主錢包，預設第一個加密幣
        if (this.isTheme('theme_purple') && this.coinList.length > 0 && !this.isCryptoExchange) {
          this.selectCrypto(this.coinList[0])
        }

        this.loadCoinApi = true
      }).catch((error) => {
        console.error('loadCoinList 發生錯誤：', error)
        setErrorMessage(error.response, this.errors)
      })
    },
    loadPaymentFee() {
      withdrawal().then((response) => {
        this.paymentFeeData = response.data.data
      }).catch((error) => setErrorMessage(error.response, this.errors))
    },
    loadTransferRate() {
      return walletTransferRate().then((response) => {
        this.transRateList = response.data.data.rate
        const matched = this.transRateList.find(
          item => item.fromCurrency === 'JPY' && item.toCurrency === 'USDT'
        )
        const rateInfo = matched.rateInfo
        const rateUSD = rateInfo.find(item => item.memo === 'USD轉為JPY的匯率')
        const rateUSDT = rateInfo.find(item => item.memo === 'USDT轉為USDT的匯率')
        this.rateJPtoUSDT = rateUSD.rate
        this.activeJPtoUSDT = rateUSD.action
        this.rateUSDTtoOther = rateUSDT.rate
        this.activeUSDTtoOther = rateUSDT.action
      }).catch((error) => setErrorMessage(error.response, this.errors))
    },
    checkAvailableWithdrawalTypes() {
      this.availableWithdrawalTypes = { 1: false, 2: false, 3: true }
      const banksByType = {}
      this.myBanks.forEach(bank => {
        if (!banksByType[bank.bank_type]) banksByType[bank.bank_type] = []
        banksByType[bank.bank_type].push(bank)
      })
      Object.entries(banksByType).forEach(([type, banks]) => {
        const hasPayments = banks.some(b => Array.isArray(b.payments) && b.payments.length > 0)
        if (hasPayments) {
          if (parseInt(type) === 1) this.availableWithdrawalTypes[1] = true
          if (parseInt(type) === 2) this.availableWithdrawalTypes[2] = true
        }
      })
    },

    // ── 工具 ─────────────────────────────────────────────────
    copyTextHelper(msg) {
      copyText(msg, this.memo)
    },

    isMobile() {
      return detectMob()
    }
  }
}
</script>

<style scoped>
.my-wrap .content {
  background-color: var(--bg-primary) !important;
  border: none !important;
  padding: 40px !important;
}
.popup-success button.button-style-5 {
  margin-left: 10px;
}
</style>
